function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 9.93601C12.0015 10.2007 11.9511 10.4631 11.8516 10.7081C11.7521 10.9531 11.6056 11.176 11.4204 11.3639L3.42584 19.4085C3.04949 19.7872 2.53905 20 2.00681 20C1.47457 20 0.96413 19.7872 0.58778 19.4085C0.21143 19.0298 -6.48593e-08 18.5162 -8.82699e-08 17.9806C-1.11681e-07 17.445 0.21143 16.9314 0.58778 16.5527L7.18327 9.93601L0.607766 3.31932C0.280338 2.93458 0.109242 2.43969 0.128671 1.93353C0.1481 1.42737 0.356623 0.947229 0.712568 0.589054C1.06851 0.230879 1.54566 0.0210532 2.04867 0.0015029C2.55168 -0.0180474 3.0435 0.154116 3.42584 0.483595L11.4204 8.5282C11.7896 8.9028 11.9978 9.4084 12 9.93601Z",
  fill: "#6A6A6A"
});

var SvgChevronRight = function SvgChevronRight(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-right.dc1b6796.svg";
export { ForwardRef as ReactComponent };